import { Box, Button, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, styled } from "@mui/material";
import dayjs from "dayjs";
import jwt_decode from "jwt-decode";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export default function DocumentosAdjuntosSolicitudGuardados(props) {

    const { documentosGuardados, setDocumentosGuardados } = props
    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    
    const idLogueado = decoded.id;

    const colocarNombreDocumento = (ruta) => {
        if(!ruta || ruta==='')
            return ''
        const indice = Number(ruta.indexOf("documentosSolicitud")) + 20
        return ruta.slice(indice)

    }

    const desplegarDocumentoPDF = async (value, tipo) => {
        //console.log(`value en desplegarDocumentoPDF ${value}`)
        await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/mostrarDocumentoPDF`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil'),
                "documento": JSON.stringify(value),
                "tipo": tipo
            },

        }
        ).then((res) => res.blob())
            .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
                var _url = window.URL.createObjectURL(blob);
                window.open(_url, "_blank").focus(); // window.open + focus
            }).catch((err) => {
                console.error(err);
            });
    }
    const columns = [
        { id: 'ruta', label: 'Documento', width: 150, align: 'center' },
        { id: 'descripcion', label: 'Descripción', width: 150, align: 'justify' },
        { id: 'autor', label: 'Usuario', width: 150, align: 'justify' },
        { id: 'createdAt', label: 'Fecha', width: 150, align: 'justify' },
        { id: 'borrar', label: '', width: 50, align: 'center' }
    ];

    const handleDelete = async (registro) => {
        //console.log(`registro ${JSON.stringify(registro)}`)
        setDocumentosGuardados(documentosGuardados.filter(documentosGuardados => documentosGuardados.id !== registro.id))
        await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/borrarDocumentoAdjunto/${registro.id}`, {
            method: "DELETE",
            headers: {
                "x-access-token": sessionStorage.getItem('token')
            }
        })
        //console.log(`${resDelete.status}`)
        await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/borrarDocumento`, {
            method: "DELETE",
            headers: {
                "x-access-token": sessionStorage.getItem('token'),
                "ruta": registro.ruta
            }
        })
       // console.log(`${resDeleteArchivo.status}`)

    }
    
    return (

        <Grid item xs={12} sm={12}>
            <Box sx={{ flexGrow: 1, marginLeft: '20px', marginTop: '50px' }}>
                <Grid container spacing={2}>
                    <Grid container xs={12} md={12} lg={12}>
                        <Grid xs={12} md={12} spacing={2}>
                            <Item>
                                <Box
                                    id="category-c"
                                    sx={{ fontSize: '12px', textTransform: 'none', fontWeight: 700, mb: 2 }}
                                >
                                    <TableContainer sx={{ mb: 5, display: !documentosGuardados || documentosGuardados.length === 0 ? 'none' : 'block', width: '100%' }}>
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow key='encabezado'>
                                                    <TableCell key='ninguna' align="center" colSpan={6}>
                                                        Documentos adjuntos registrados
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='encabezado2'>
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            style={{ top: 57, minWidth: column.minWidth }}
                                                        >
                                                            {column.label}
                                                        </TableCell>

                                                    ))}
                                                    <TableCell style={{ top: 57 }}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    documentosGuardados && documentosGuardados.length > 0 ? documentosGuardados
                                                        .map((row, index) => {
                                                            return (
                                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.indice}>
                                                                    {
                                                                        columns.map((column) => {
                                                                            const value = row[column.id];

                                                                            // total=Number(total)+Number(value)
                                                                            // console.log(`column.id ${column.id} row[column.id] ${row[column.id]}`)                    
                                                                            return (
                                                                                <TableCell key={column.id} align={column.align} style={{ wordBreak: 'break-word' }}>
                                                                                    {column.id === 'ruta' ? <Button size='small' variant="text" style={{ marginTop: 20, color: 'darkgreen', width: '100%', textTransform: "none" }} onClick={async () => { await desplegarDocumentoPDF(row) }}><span style={{ wordBreak: 'normal', whiteSpace: 'nowrap' }}>{colocarNombreDocumento(value)}</span></Button> : 
                                                                                        column.id === 'createdAt'?dayjs(value).format('DD MMMM YYYY'):value}
                                                                                </TableCell>
                                                                            );
                                                                        })}
                                                                    <TableCell>{row.idAutor===idLogueado ? <Tooltip title="Eliminar"><IconButton variant='text' style={{ color: 'darkred' }} onClick={() => handleDelete(row)}><i className="bi bi-trash3"></i></IconButton></Tooltip>:<></>}</TableCell>
                                                                </TableRow>
                                                            );
                                                        }) : <TableRow hover role="checkbox" tabIndex={-1} >

                                                        <TableCell align='center' colSpan={6}>
                                                            No hay comprobantes registrados
                                                        </TableCell>

                                                    </TableRow>}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
}

